import { IPage } from './page';

export interface ITutorial {
  tutorialId?: number;
  index?: number;
  slug?: string;
  title?: string;
  description?: string;
  difficulty?: number;
  pageCount?: number;
  imageUrl?: string;
  published?: boolean;
  pages?: IPage[];
}

export class Tutorial implements ITutorial {
  tutorialId?: number;
  index?: number;
  slug?: string;
  title?: string;
  description?: string;
  difficulty?: number;
  pageCount?: number;
  imageUrl?: string;
  published?: boolean;
  pages?: IPage[];

  constructor(tutorial: ITutorial = {}) {
    this.tutorialId = tutorial.tutorialId;
    this.index = tutorial.index;
    this.slug = tutorial.slug;
    this.title = tutorial.title;
    this.description = tutorial.description;
    this.difficulty = tutorial.difficulty;
    this.pageCount = tutorial.pageCount;
    this.imageUrl = tutorial.imageUrl;
    this.published = tutorial.published;
    this.pages = [];
  }
}
